import React from "react";

const Plus = ({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 27.715 27.715"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
  <path id="Path_216" data-name="Path 216" d="M89.269,24.686H78.16v-9.94a1.77,1.77,0,0,0-1.754-1.7,1.866,1.866,0,0,0-1.754,1.7v9.94H64.946a1.771,1.771,0,0,0-1.7,1.754,1.866,1.866,0,0,0,1.7,1.754h9.706V39.069a1.771,1.771,0,0,0,1.754,1.7,1.866,1.866,0,0,0,1.754-1.7V28.194H89.269a1.755,1.755,0,0,0,0-3.508Z" transform="translate(-63.25 -13.05)" fill="#0073a7"/>
  </svg>
);

const Up = ({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 14.97 15.603"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Group_35" data-name="Group 35" transform="translate(-465.28 -15.7)">
      <path id="Path_326" data-name="Path 326" d="M480.29,19.865,473.125,12.7l-7.165,7.165a1.009,1.009,0,0,0-.318.716.973.973,0,0,0,.318.716,1.009,1.009,0,0,0,.716.318.972.972,0,0,0,.716-.318l4.7-4.7V27.268a.973.973,0,0,0,.318.716,1.009,1.009,0,0,0,.716.318.972.972,0,0,0,.716-.318,1.009,1.009,0,0,0,.318-.716V16.442l4.856,4.856a1.009,1.009,0,0,0,.717.318.972.972,0,0,0,.716-.318A1.212,1.212,0,0,0,480.29,19.865Z" transform="translate(-0.362 3)" fill="#0072a9"/>
    </g>
  </svg>
);

const Confirm = ({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 21.442 16.313"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    fill={fill}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
  <path id="Path_329" data-name="Path 329" d="M33.342,17.53A1.7,1.7,0,0,0,31.7,15.8a1.544,1.544,0,0,0-1.17.494h0L20.243,27.252,14.629,21.32h0a1.8,1.8,0,0,0-1.092-.412,1.7,1.7,0,0,0-1.637,1.73,1.616,1.616,0,0,0,.39,1.071h0l.078.082.078.082,7.8,8.239.546-.577,12.085-12.77h0A1.728,1.728,0,0,0,33.342,17.53Z" transform="translate(-11.9 -15.8)"/>
  </svg>
);


const Cancel = ({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 13.708 13.771"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path id="Path_332" fill={fill} data-name="Path 332" d="M25.742,122.719l4.628-4.628a1.236,1.236,0,0,0,.371-.943,1.257,1.257,0,0,0-.267-.809l-.1-.134a1.307,1.307,0,0,0-1.824,0l-4.628,4.628-4.627-4.627a1.233,1.233,0,0,0-.944-.372,1.46,1.46,0,0,0-.876.315l-.066.055a1.118,1.118,0,0,0-.372.944,1.455,1.455,0,0,0,.316.876l4.683,4.7L17.4,127.346a1.235,1.235,0,0,0-.372.944,1.26,1.26,0,0,0,.266.808l.105.135a1.309,1.309,0,0,0,1.825,0l4.627-4.628,4.628,4.627a1.233,1.233,0,0,0,.943.372,1.452,1.452,0,0,0,.848-.293,1.078,1.078,0,0,0,.466-1.022,1.332,1.332,0,0,0-.371-.943Z" transform="translate(-17.033 -115.834)"/>
  </svg>
);



const Image = ({
  style = {},
  fill = "#0073A7",
  width = "100%",
  className = "",
  viewBox = "0 0 22.548 17.078"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
  <path id="Path_333" data-name="Path 333" d="M17.2,3.6,14.694,0H7.853l-2.5,3.6H0V17.078H22.548V3.6ZM8.543,1.321H14L15.586,3.6H6.961ZM21.226,15.757H1.321V4.918H21.226Zm0,0" fill={fill}/>
  <path id="Path_334" data-name="Path 334" d="M155.777,127.859a4.617,4.617,0,1,0,4.617,4.617A4.622,4.622,0,0,0,155.777,127.859Zm0,7.913a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,155.777,135.772Zm0,0" transform="translate(-144.503 -122.229)" fill={fill}/>
  <path id="Path_335" data-name="Path 335" d="M432.52,129.18a.661.661,0,1,0-.661-.661A.66.66,0,0,0,432.52,129.18Zm0,0" transform="translate(-412.841 -122.229)" fill={fill}/>
  </svg>
);

const Locationpin = ({
  style = {},
  fill = "#0073A7",
  width = "100%",
  className = "",
  viewBox = "0 0 14.71 19.652"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path id="Path_336" data-name="Path 336" d="M109.845,168.452l0-.047a7.355,7.355,0,0,0-14.688,0l0,.031c-.006.125-.009.25-.009.371a7.345,7.345,0,0,0,1.852,4.879l.023.029,5.485,7.39,5.655-7.6.007-.008a7.424,7.424,0,0,0,.456-.613l.053-.081a7.327,7.327,0,0,0,1.179-3.995C109.853,168.691,109.85,168.571,109.845,168.452Zm-7.347,4.473a4.118,4.118,0,1,1,4.118-4.118A4.118,4.118,0,0,1,102.5,172.925Z" transform="translate(-95.143 -161.452)" fill={fill}/>
    </svg>
);



const Edit = ({
  style = {},
  fill = "#0073A7",
  width = "100%",
  className = "",
  viewBox = "0 0 21.781 21.53"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
      <g id="Group_37" data-name="Group 37" transform="translate(-478 50.212)">
      <g id="Group_36" data-name="Group 36" transform="translate(480.984 -50.213)">
        <path id="Path_330" data-name="Path 330" d="M499.747-46.226l-14.8,14.8c0-.136-3.5-3.5-3.3-3.3l14.8-14.8a2.336,2.336,0,0,1,3.3,0A2.336,2.336,0,0,1,499.747-46.226Z" transform="translate(-481.633 50.213)" fill="#0073a7"/>
      </g>
      <path id="Path_331" data-name="Path 331" d="M479.643-30,478-25.072l4.928-1.643L479.643-30" transform="translate(0 -3.611)" fill="#0073a7"/>
      </g>


    </svg>
);


const Delete = ({
  style = {},
  fill = "#0073A7",
  width = "100%",
  className = "",
  viewBox = "0 0 512 512"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g>
      <g>
        <g>
          <polygon fill={fill} points="353.574,176.526 313.496,175.056 304.807,412.34 344.885,413.804 			"/>
          <rect fill={fill} x="235.948" y="175.791" width="40.104" height="237.285"/>
          <polygon fill={fill} points="207.186,412.334 198.497,175.049 158.419,176.52 167.109,413.804 			"/>
          <path fill={fill} d="M17.379,76.867v40.104h41.789L92.32,493.706C93.229,504.059,101.899,512,112.292,512h286.74
            c10.394,0,19.07-7.947,19.972-18.301l33.153-376.728h42.464V76.867H17.379z M380.665,471.896H130.654L99.426,116.971h312.474
            L380.665,471.896z"/>
        </g>
      </g>
    </g>
    <g>
      <g>
        <path fill={fill} d="M321.504,0H190.496c-18.428,0-33.42,14.992-33.42,33.42v63.499h40.104V40.104h117.64v56.815h40.104V33.42
          C354.924,14.992,339.932,0,321.504,0z"/>
      </g>
    </g>
    </svg>
);



const Rotate = ({
  style = {},
  fill = "#0073A7",
  width = "100%",
  className = "",
  viewBox = "0 0 520.09 687.27"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="M292.13,1.22a17.07,17.07,0,0,0-9.54,22.17l23.07,57.92c-113.11-46.52-242.5,7.46-289,120.57a221.45,221.45,0,0,0-.76,166.56,17.07,17.07,0,1,0,31.71-12.63C9.24,259.48,56.24,150.3,152.57,112a187.75,187.75,0,0,1,151.18,5.41l-60.91,51.4a17.09,17.09,0,0,0,22,26.13l82.5-69.6a17.08,17.08,0,0,0,4.84-19.41L314.3,10.75A17.06,17.06,0,0,0,292.13,1.22Z"/>
    <path d="M520.09,687.27H163.73V252.6H520.09Zm-326.36-30H490.09V282.6H193.73Z"/>
    </svg>
);






export default Plus;
export { Up, Cancel, Confirm,Image,Locationpin,Edit,Delete, Rotate };